// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WXP61","content":"styles_content__iGD2y"};